import React from "react";
import { RedirectPage } from "@payment-client/components/show-payments/components/redirect-page";
import { ShowPayments } from "@payment-client/components/show-payments";
import { PaymentRenderer } from "@payment-client/components/show-payments/components/payment-renderer";
import { PaymentLinkPayLater } from "@payment-client/components/show-payments/components/link-paylater";
import LinkPaylaterFullPage from "@payment-client/components/show-payments/components/link-paylater/link-full-page-view/LinkFullPage";
import { AddNewCardPayment } from "@payment-client/components/show-payments/components/add-new-card";
import { PaymentVerifyVpa } from "@payment-client/components/show-payments/components/verify-vpa";
import { NetBankingMoreBanks } from "@payment-client/components/show-payments/components/more-banks";
import { VpaTimer } from "@payment-client/components/vpa-timer";
import { PaymentTxnStatusPoller } from "@payment-client/components/upi-intent-poller";
import { MorePaymentGroups } from "@payment-client/components/show-payments/components/more-payment-groups";
import { MorePaymentMethods } from "@payment-client/components/show-payments/components/more-payment-methods";
import { ConfirmOrder } from "@payment-client/components/confirm-order";
import { DirectPlaceOrder } from "@payment-client/components/direct-place-order";
import { SwiggyMoneyPaymentsContainer } from "@payment-client/components/show-payments/components/swiggy-money-payments/SwiggyMoneyPaymentsContainer";
import { AddSwiggyMoneyContainer } from "@payment-client/components/show-payments/components/swiggy-money-payments";
import { VerifyWalletLinkOTP } from "@payment-client/components/show-payments/components/verify-wallet-link-otp";
import { LinkWalletWithNumber } from "@payment-client/components/show-payments/components/link-wallet-with-number";
import { PaymentOffers } from "@payment-client/components/show-payments/components/payment-offers-renderer";
import DineoutDirectPlaceOrder from "@payment-client/components/show-payments/components/dineout-direct-place-order/DineoutDirectPlaceOrder";
import { EmiSelection } from "@payment-client/components/emi-selection/EmiSelection";

import AutopayPaymentFailureScreen from "@payment-client/components/autopay-payment-failure-screen";

// Routes
import { CheckoutRoute } from "@swiggy-private/checkout-core";
import { LinkPayLaterWithNumber } from "@payment-client/components/show-payments/components/link-paylater-with-number";

export const PaymentRoutes = [
    <ShowPayments
        name={CheckoutRoute.PAYMENTS}
        indexElement={<PaymentRenderer name={CheckoutRoute.PAYMENTS_INDEX} />}
        key={CheckoutRoute.PAYMENTS}
    >
        <VerifyWalletLinkOTP name={CheckoutRoute.VERIFY_WALLET_LINK_OTP} />
        <LinkWalletWithNumber name={CheckoutRoute.LINK_WALLET_WITH_NUMBER} />
        <PaymentLinkPayLater name={CheckoutRoute.LINK_PAYLATER} />
        <LinkPayLaterWithNumber name={CheckoutRoute.LINK_PAYLATER_MOBILE} />
        <AddNewCardPayment name={CheckoutRoute.ADD_NEW_CARD} />
        <PaymentVerifyVpa name={CheckoutRoute.VERIFY_VPA} />
        <NetBankingMoreBanks name={CheckoutRoute.MORE_BANKS} />
        <VpaTimer name={CheckoutRoute.VPA_TIMER} />
        <PaymentTxnStatusPoller name={CheckoutRoute.PAYMENT_TXN_STATUS_POLLING} />
        <MorePaymentGroups name={CheckoutRoute.MORE_PAYMENT_GROUPS} />
        <MorePaymentMethods name={CheckoutRoute.MORE_PAYMENT_METHODS} />
<AutopayPaymentFailureScreen name={CheckoutRoute.AUTOPAY_ELIGIBLE_PAYMENT_FAILED} />
        <LinkPaylaterFullPage name={CheckoutRoute.PAYLATER_LINKING_CONFIRMATION} />
        <PaymentOffers name={CheckoutRoute.PAYMENT_OFFERS} />
        <EmiSelection name={CheckoutRoute.EMI_SELECTION} />
    </ShowPayments>,

    <SwiggyMoneyPaymentsContainer
        name={CheckoutRoute.ADD_SWIGGY_MONEY}
        indexElement={<AddSwiggyMoneyContainer name={CheckoutRoute.ADD_SWIGGY_MONEY_INDEX} />}
        key={CheckoutRoute.ADD_SWIGGY_MONEY}
    >
        <ShowPayments
            name={CheckoutRoute.SWIGGY_MONEY_PAYMENTS}
            indexElement={<PaymentRenderer name={CheckoutRoute.SWIGGY_MONEY_PAYMENTS} />}
        >
            <AddNewCardPayment name={CheckoutRoute.ADD_NEW_CARD} />
            <NetBankingMoreBanks name={CheckoutRoute.MORE_BANKS} />
            <PaymentTxnStatusPoller name={CheckoutRoute.PAYMENT_TXN_STATUS_POLLING} />
            <MorePaymentMethods name={CheckoutRoute.MORE_PAYMENT_METHODS} />
        </ShowPayments>
    </SwiggyMoneyPaymentsContainer>,
    <ConfirmOrder name={CheckoutRoute.CONFIRM_ORDER} key={CheckoutRoute.CONFIRM_ORDER} />,
    <DirectPlaceOrder name={CheckoutRoute.DIRECT_PLACE_ORDER} key={CheckoutRoute.DIRECT_PLACE_ORDER} />,
    <RedirectPage name={CheckoutRoute.REDIRECT_PAGE} key={CheckoutRoute.REDIRECT_PAGE} />,
    <DineoutDirectPlaceOrder
        name={CheckoutRoute.DINEOUT_DIRECT_PLACE_ORDER}
        key={CheckoutRoute.DINEOUT_DIRECT_PLACE_ORDER}
    />,
];
